import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import useNavigation from 'core/hooks/useNavigation'
import { AcceptInviteUrl, DashboardUrl } from 'constants/RouteUrls'
import { setAuthTokenCookie } from 'utils/AppHelper'

const SamlCallbackPage = () => {
  const { push } = useNavigation()
  const location = useLocation()
  useEffect(() => {
    const jwt = new URLSearchParams(location.search).get('jwt')
    const inviteToken = new URLSearchParams(location.search).get('invite_token')
    if (jwt) {
      setAuthTokenCookie(jwt)
    }

    if (inviteToken) {
      push(AcceptInviteUrl)
    } else {
      push(DashboardUrl)
    }
  }, [location.search, push])
  return null
}
export default SamlCallbackPage
